/* ETOILE mobile swatch scroll isolation */
(() => {
  const marker = 'etoileMobileSwatchScroll';
  const selector = '.product-grid-item__swatch';
  const boundRows = new WeakSet();

  const bindRow = (row) => {
    if (boundRows.has(row)) return;
    boundRows.add(row);

    row.style.overflowX = 'auto';
    row.style.overflowY = 'hidden';
    row.style.webkitOverflowScrolling = 'touch';
    row.style.overscrollBehaviorX = 'contain';
    row.style.touchAction = 'pan-x';

    const keepGestureInRow = (event) => {
      event.stopPropagation();
    };

    row.addEventListener('touchstart', keepGestureInRow, { passive: true });
    row.addEventListener('touchmove', keepGestureInRow, { passive: true });
    row.addEventListener('pointerdown', keepGestureInRow, { passive: true });
    row.addEventListener('pointermove', (event) => {
      event.stopImmediatePropagation();
    }, { capture: true, passive: true });
  };

  const bindRows = (root = document) => {
    if (root.matches?.(selector)) bindRow(root);
    root.querySelectorAll?.(selector).forEach(bindRow);
  };

  if (!document.documentElement.dataset[marker]) {
    document.documentElement.dataset[marker] = 'true';

    const style = document.createElement('style');
    style.textContent = [
      '@media (max-width: 767px) {',
      '  .product-grid-item__swatch {',
      '    min-width: 0;',
      '    max-width: 100%;',
      '    overflow-x: auto !important;',
      '    overflow-y: hidden !important;',
      '    -webkit-overflow-scrolling: touch;',
      '    overscroll-behavior-x: contain;',
      '    touch-action: pan-x !important;',
      '    scrollbar-width: none;',
      '  }',
      '  .product-grid-item__swatch::-webkit-scrollbar { display: none; }',
      '  .product-grid-item__swatch > .swatch__button { flex: 0 0 auto; }',
      '}',
    ].join('\n');
    document.head.appendChild(style);

    bindRows();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) bindRows(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
